import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { IProfileData } from "store/types";

interface IPersonCardProps {
  person: IProfileData;
  isFull: boolean;
  onClick?: () => void;
}

export const PersonCard: React.FC<IPersonCardProps> = ({ person, isFull, onClick }) => {
  const { full_name, first_name, last_name, position, company_name, location, profile_photo_url } = person.details;

  return (
    <Stack
      onClick={onClick}
      sx={{
        borderRadius: "8px",
        p: "12px",
        gap: "10px",
        ...(isFull ? { flex: 1 } : { flexShrink: 0 }),
        maxHeight: "270px",
        overflow: "hidden",
        backgroundColor: "#F6F8FC",
        border: "1px solid transparent",
        cursor: "pointer",
        transition: "background-color 0.2s, box-shadow 0.2s, border-color 0.2s",
        "&:hover": {
          backgroundColor: "#E5EAF2",
          boxShadow: "0px 4px 12px rgba(7, 31, 53, 0.12)",
          borderColor: "#071f35"
        }
      }}
    >
      {profile_photo_url ? (
        <Box
          component="img"
          src={profile_photo_url}
          alt={full_name}
          sx={{ width: "100%", height: "135px", borderRadius: "6px", objectFit: "cover", flexShrink: 0 }}
        />
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "135px",
            flexShrink: 0,
            borderRadius: "6px",
            backgroundColor: "#D6E8FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography sx={{ fontSize: "36px", fontWeight: 600, color: "#2A7CDC", lineHeight: 1 }}>
            {first_name?.[0]?.toUpperCase()}
            {last_name?.[0]?.toUpperCase()}
          </Typography>
        </Box>
      )}

      <Stack gap="2px">
        <Typography
          variant="body1"
          sx={{
            fontWeight: 700,
            color: "#071F35",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {full_name}
        </Typography>
        <Typography
          variant="body3"
          sx={{
            color: "#071F35",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden"
          }}
        >
          {position}
        </Typography>
        <Typography
          variant="body4"
          sx={{
            color: "#496682",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {company_name}
        </Typography>
        <Typography
          variant="body4"
          sx={{
            fontWeight: 500,
            color: "#496682",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {location}
        </Typography>
      </Stack>
    </Stack>
  );
};
